import { render, staticRenderFns } from "./CommentObjects.vue?vue&type=template&id=719bce92&"
import script from "./CommentObjects.vue?vue&type=script&lang=ts&"
export * from "./CommentObjects.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports